//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgSquareWarning } from '../icons/SquareWarning';

export function SquareWarningIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgSquareWarning} data-qa="SquareWarningIcon">
      <svg />
    </SvgIcon>
  );
}
